import { httpClientUser } from 'Api/microservice-http-clients';

export async function getCustodianList() {
  const { data } = await httpClientUser.get('/custodians');
  return data;
}
